import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import styled from "styled-components";

const DeleteButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
`;

import {
  constructStripeNegativeBalanceButton,
  constructIsErrorButton,
  constructConfirmDeletionBtn,
} from "./modalMessage";

function StripeAccountDeletionModalFooter({
  pageLoading,
  balance,
  isError,
  loading,
  showDeleteButton,
  onCancel,
  onConfirmDeletion,
}) {
  const [message, setMessage] = useState(constructConfirmDeletionBtn(loading, onConfirmDeletion));
  const isStripeBalanceNegative = balance.actualBalance < 0;
  useEffect(() => {
    if (isStripeBalanceNegative) {
      setMessage(constructStripeNegativeBalanceButton(showDeleteButton, onCancel));
    } else if (isError) {
      setMessage(constructIsErrorButton(showDeleteButton, onCancel));
    } else {
      setMessage(constructConfirmDeletionBtn(loading, onConfirmDeletion));
    }
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balance, isError, loading]);

  return <DeleteButtonContainer>{pageLoading ? <Spin /> : message}</DeleteButtonContainer>;
}
export { StripeAccountDeletionModalFooter };
